import React, { FC } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EconsultCancelButton } from '@oh-vcp/components-ui';

interface EconsultDraftWarningDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EconsultDraftWarningDialog: FC<EconsultDraftWarningDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <Typography variant="h3" color="base.grey3">
          {t('Case.consult.warning')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="base.grey3">
          {t('Case.consult.draftNoteWillBeDeleted')}
        </Typography>
        <Grid container item xs={12} justifyContent="flex-end" pt={3}>
          <Button variant="contained" color="primary" sx={{ mr: 1 }} onClick={onConfirm}>
            {t('Case.button.confirm')}
          </Button>
          <EconsultCancelButton variant="contained" onClick={onCancel}>
            {t('Case.button.cancel')}
          </EconsultCancelButton>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultDraftWarningDialog;
